import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { SelectLabels, SelectPercentBooking, SelectPercentBought, SelectUTMOverallStatus, SelectVisitors, SelectWeeks, graphUTMOverall } from "./utmOverallSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";
import { VisitorNumbersByOverallUTM } from "../../../../components/Graphs/MarketingPerformanceGraphs/Analytics/VisitorNumbersByOverallUTM";

const UTMOverall = () => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

  const UTMOverallData = useSelector((state) => state.utmOverall);
  console.log("UTMOverallData", UTMOverallData)
  const loading = useSelector(SelectUTMOverallStatus);
  const weeks = useSelector(SelectWeeks);
  const visitors = useSelector(SelectVisitors);
  const percentBooking = useSelector(SelectPercentBooking);
  const percentBought = useSelector(SelectPercentBought);
  const adsLabels = useSelector(SelectLabels);

  
  useEffect(() => {
    if (!user) return null;
    if(weeks.length===0) dispatch(graphUTMOverall(user));
  }, [user, weeks]);

  if (loading === "loading") return <SingleGraphLoading />;
  return (
    <VisitorNumbersByOverallUTM
    loading={loading === "loading"}
    display={"Testing"}
    weeks={weeks}
    visitors={visitors}
    percentOfBooking={percentBooking}
    nameLabels={adsLabels}
    totalSales={percentBought}
    />
  )
};

export default UTMOverall;